import { useEffect, useState } from 'react'
import Layout from 'containers/Layout'
import { Route, Switch, useHistory, useParams, useLocation } from 'react-router-dom'
import UserProfile from 'pages/users/UserProfile'
import apiGet from 'lib/network/apiGet'
import { getResourceData } from 'lib/utils/resource'
import useModal from 'hooks/useModal'
import PasswordRest from './modals/PasswordModal'
import { useGet } from 'hooks/useApi'
import LanguageSwitcher from 'components/atoms/LanguageSwitcher'

const AddUser = ({ readOnly, currentUserId }) => {
  const { response: rolesResponse } = useGet('roles')

  const roles = rolesResponse?.data || []

  const history = useHistory()
  const location = useLocation()

  const [isEdit, setIsEdit] = useState(null)
  const [userData, setUserData] = useState({})

  const [loading, setLoading] = useState(false)

  const id = useParams()?.id || currentUserId

  const navigateToUsersList = () => {
    const searchParams = new URLSearchParams(location.search)
    const queryString = searchParams.toString()
    const usersPath = queryString ? `/users?${queryString}` : '/users'
    history.push(usersPath)
  }

  useEffect(() => {
    if (id) {
      setIsEdit(true)
      fetchUser(id)
    }
  }, [id])

  const fetchUser = async () => {
    setLoading(true)
    const data = getResourceData(await apiGet(`user/${id}`))
    setLoading(false)

    if (!data) {
      navigateToUsersList()
      return
    }

    setUserData(data)
  }

  const [PasswordResetModal, openPasswordResetModal, closeModal] = useModal({
    content: <PasswordRest fetchUser={fetchUser} />,
    title: 'Update Password',
    // dimensions: {
    //   height: '320px',
    //   width: '450px',
    // },
    dimensions: {
      height: 'auto',
      width: '90vw',
      maxWidth: '500px',
      minHeight: 'auto',
      minWidth: '280px',
    },
  })

  return (
    <Layout
      headerRight={
        <div className="mt-4 flex flex-col sm:flex-row sm:items-center sm:mt-0 sm:ml-4 gap-3">
          <button
            onClick={openPasswordResetModal}
            type="button"
            className="inline-flex items-center justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-white bg-dark-600 hover:bg-dark-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dark-500"
          >
            Password Reset
          </button>
          <button
            onClick={navigateToUsersList}
            type="button"
            className="inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-dark-600 hover:bg-dark-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dark-500"
          >
            Go Back
          </button>
        </div>
      }
      title={isEdit ? 'Edit User' : 'Add New User'}
      breadcrumbs={[
        { name: 'Users', pathname: '/users' },
        { name: isEdit ? 'User Details' : 'Add New Users', pathname: '/users/add', current: true },
      ]}
    >
      <div className="w-full overflow-auto px-2 sm:px-4 md:px-6">
        <div className="w-full max-w-full">
          {currentUserId ? (
            <UserProfile readOnly={readOnly} refetch={fetchUser} userData={userData} loading={loading} id={id} isEdit={isEdit} roles={roles} />
          ) : (
            <Switch>
              <Route key={id} path="/users/add" component={() => <UserProfile id={id} isEdit={isEdit} roles={roles} />} />
              <Route
                key={id}
                path="/users/edit/:id"
                component={() => <UserProfile readOnly={readOnly} refetch={fetchUser} userData={userData} loading={loading} id={id} isEdit={isEdit} roles={roles} />}
              />
            </Switch>
          )}
        </div>
      </div>
      <PasswordResetModal />
    </Layout>
  )
}
export default AddUser
